/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Switch } from '@/utils/switch';
import { SxProps, Theme } from '@mui/material';

export const alertSX = (severity: string): SxProps<Theme> => ({
	'.MuiAlert-message': {
		whiteSpace: 'normal',
		overflowWrap: 'break-word',
		wordWrap: 'break-word',
		wordBreak: 'break-word',
	},
	backgroundColor: Switch(severity)
		.case('info', () => '#F0F7FF')
		.defaultTo(() => undefined),
	boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
	color: Switch(severity)
		.case('info', () => '#2682E7')
		.defaultTo(() => undefined),
});
